import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Clock, Mail, LogOut, RefreshCw } from 'lucide-react';

const PendingApproval = () => {
  const { user, logout, refreshUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // 如果用戶已批准，跳轉到創作頁面
    if (user?.status === 'approved') {
      navigate('/create', { replace: true });
    }
  }, [user, navigate]);

  const handleRefresh = async () => {
    await refreshUser();
  };

  return (
    <div
      data-atelier="true"
      className="min-h-screen flex items-center justify-center p-4 bg-atelier-bg atelier-paper relative"
    >
      <div className="max-w-lg w-full relative">
        {/* Main Card — Atelier */}
        <div className="atelier-card p-10 text-center relative overflow-hidden">
          {/* Animated Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full mb-6 border-2 border-atelier-coral/40 bg-atelier-coral/10 atelier-breathe">
            <Clock className="w-12 h-12 text-atelier-coral" strokeWidth={1.8} />
          </div>

          {/* Title */}
          <h1
            className="text-3xl mb-3 tracking-tight text-atelier-ink"
            style={{ fontFamily: "'Noto Serif TC', Georgia, serif", fontWeight: 500 }}
          >
            帳號審核中
          </h1>

          {/* Message */}
          <p className="text-atelier-mute text-base leading-relaxed mb-2">
            感謝您註冊 <span className="font-semibold text-atelier-coral">Reelscript AI</span>！
          </p>
          <p className="text-atelier-mute text-base leading-relaxed mb-8">
            您的帳號正在審核中，我們會盡快處理您的申請。
            審核通過後，您將可以立即開始使用所有功能。
          </p>

          {/* Info Box */}
          <div className="border-l-2 border-atelier-coral bg-atelier-coral/5 rounded-xl p-5 mb-8 text-left">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-atelier-coral mt-0.5 flex-shrink-0" strokeWidth={1.6} />
              <div>
                <p className="font-semibold text-atelier-ink mb-1.5">審核狀態更新</p>
                <p className="text-sm text-atelier-mute leading-relaxed">
                  審核通過後，我們會發送郵件通知到{' '}
                  <span className="font-medium text-atelier-ink">{user?.email}</span>。
                  屆時您即可登入使用。
                </p>
              </div>
            </div>
          </div>

          {/* User Info */}
          <div className="mb-8 p-4 bg-atelier-surface2 rounded-xl border border-atelier-line">
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="text-left">
                <p className="atelier-caption mb-1">註冊郵箱</p>
                <p className="font-medium text-atelier-ink">{user?.email}</p>
              </div>
              <div className="text-left">
                <p className="atelier-caption mb-1">註冊時間</p>
                <p className="font-medium text-atelier-ink">
                  {user?.created_at && new Date(user.created_at).toLocaleDateString('zh-TW')}
                </p>
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-3">
            <Button
              onClick={handleRefresh}
              variant="outline"
              className="flex-1 rounded-full border-atelier-lineHi text-atelier-ink hover:bg-atelier-surface2 h-11"
            >
              <RefreshCw className="w-4 h-4 mr-2" strokeWidth={1.6} />
              重新檢查狀態
            </Button>
            <Button
              onClick={logout}
              variant="outline"
              className="flex-1 rounded-full border-red-400/50 text-red-500 hover:bg-red-500/10 h-11"
            >
              <LogOut className="w-4 h-4 mr-2" strokeWidth={1.6} />
              登出
            </Button>
          </div>

          {/* Footer Note */}
          <p className="atelier-caption mt-6">
            通常審核會在 24 小時內完成。如有疑問，請聯繫客服。
          </p>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
